import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Si è verificato un errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const SITE = {
  name: "Scuola Didattica Sicura",
  legalName: "Scuola Didattica Sicura S.r.l.",
  phone: "0302470948",
  phoneDisplay: "030 2470948",
  email: "info@scuoladidatticasicura.it",
  address: "Via Sostegno 25, 24124 Brescia (BS)",
  piva: "03848480988",
  hours: "10.00 – 16.00, dal lunedì al venerdì",
};
